/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {executeSetPostalCode} from '../api'

export const useMutationExecuteSetPostalCode = createReactQueryMutationHook('executeSetPostalCode', executeSetPostalCode)
